import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import style from './style.module.less';
import messages from '../messages';

export const FileStatusLabel = ({ className = null, wrapperClassname = '' }) => {
  return (
    <div className={classnames(className, style.success)}>
      <div className={classnames(style['status-label-wrapper'], wrapperClassname)}>
        <div className={style.pill} />
        <div className={style['status-text']}>
          <FormattedMessage {...messages.fileStatusExportSuccessful} />
        </div>
      </div>
    </div>
  );
};

FileStatusLabel.propTypes = {
  className: PropTypes.string,
  wrapperClassname: PropTypes.string,
};
